import { defineComponent as _defineComponent } from 'vue'
import { onMounted } from 'vue'
  import type { PropType } from 'vue'
  import type { LessonChangeLog } from '@/services/interfaces/Course'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useCourse from '@/composables/useCourse'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useSegment from '@/composables/useSegment'
  import { UserModule } from '@/store/modules/user'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseChangesModal',
  props: {
    lessonChanges: {
      type: Object as PropType<{ [key: string]: LessonChangeLog[] }>,
      required: true,
    },
  },
  setup(__props) {

  const { course } = useCourse()
  const { lessonCompletedIcon, open } = useIcons()
  const { courseChangesModalShown } = useSegment()

  

  onMounted(() => {
    if (course.value) {
      courseChangesModalShown(UserModule.email, course.value.id)
    }
  })

return { __sfc: true,course, lessonCompletedIcon, open, courseChangesModalShown, onMounted, SVGRenderer, useIcons, useCourse, KetchUpButton, LoadingSpinner, useSegment, UserModule }
}

})